var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    { attrs: { small: true } },
    [
      _vm.$wait.is("fetching preview resource")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : [
            _c(
              "template",
              { slot: "header" },
              [
                _c("ContentHeader", {
                  attrs: {
                    title: _vm.sectorTitle,
                    "back-link-title": "Go Back",
                    "back-link": `/sectors/${_vm.sectorId}`,
                    bordered: false,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("CreatePost", {
              ref: "createPostForm",
              attrs: {
                "is-editing": true,
                "sector-id": _vm.sectorId,
                "default-values": _vm.formDataDefaultValues,
              },
              on: { "form-submit": _vm.handleFormSubmit },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "delete-button",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.handleDeleteClicked.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Delete Post")]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }